<script setup>
import DialogBase from "@/components/dialog/DialogBase.vue";
</script>

<template>
    <DialogBase
        :dialog="{
                message: 'Invoice request',
                type: 'request-invoice-dropper'
            }"
    >
        Please upload your invoice

    <!--
        Show:
            - name of issuer
            - data of counterparty
                - Company name
                - Address
                - ICO, DIC
            - amount and currency
            - project if exists
    -->
    </DialogBase>

</template>

<style scoped lang="scss">

</style>